import React from 'react';
import ChestnyZnakCodeChecker from '../components/ChestnyZnakCodeChecker';

const ChestnyZnakChecker = () => {
    return (
        <ChestnyZnakCodeChecker />
    );
};

export default ChestnyZnakChecker;